import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/term-of-service/page.tsx");
